import 'src/index.css'

/** Any critical dependencies may be added to the following `allSettled` array and handled as needed
 *
 * In this case, we are importing the app and i18n modules and initializing the app if the promise is fulfilled.
 *
 * This ensures that the app in localised and ready to go before the app is initialized however we are not handling any errors that may occur during the import process but we are logging to NR.
 */
Promise.allSettled([import('src/app'), import('src/i18n')]).then((results) => {
  const app = results[0]
  if (app.status === 'fulfilled') {
    app.value.init()
  }
  if (window?.newrelic?.noticeError) {
    results.forEach((result) => {
      if (result.status === 'rejected') {
        const error = new Error('Failed to load app module')
        error.stack = result.reason
        window.newrelic.noticeError(error)
      }
    })
  }
})
